import { useGetCustomHeaders } from "@vega-api/custom/stores/useGetCustomHeaders";
import { useGetDealOpportunitiesForLimitedPartnerV2 } from "@vega-api/generated/deal-opportunity-lp-view/deal-opportunity-lp-view";
import { SearchableDropdown } from "@vega-core/components/Form/Controls/SearchableDropdown/SearchableDropdown";
import { type OptionType } from "@vega-core/models/options";
import { m } from "@vega-core/paraglide/messages";

const ALL_DEALS_VALUE = "__all_deals__";

type Props = {
  value?: string;
  onChange: (opportunityId: string | undefined) => void;
};

export const NotificationsDealFilterDropdown = ({ value, onChange }: Props) => {
  const { limitedPartnerId } = useGetCustomHeaders();

  const { data: dealOpportunities, isLoading } =
    useGetDealOpportunitiesForLimitedPartnerV2(
      { limitedPartnerId: limitedPartnerId! },
      {
        query: {
          enabled: !!limitedPartnerId,
          select: (response) => response.data,
        },
      },
    );

  const allDealsOption: OptionType = {
    label: m.coInvestments_notifications_allDeals(),
    value: ALL_DEALS_VALUE,
  };
  const options: OptionType[] = [
    allDealsOption,
    ...(dealOpportunities ?? []).map((item) => ({
      label: item.deal.name || "-",
      value: item.dealOpportunity.id,
    })),
  ];

  const selectedOption =
    (value ? options.find((option) => option.value === value) : undefined) ??
    allDealsOption;

  return (
    <SearchableDropdown
      className="w-full sm:w-80"
      isLoading={isLoading}
      name="coinvestNotificationsDealFilter"
      onChange={(option) =>
        onChange(
          option && option.value !== ALL_DEALS_VALUE ? option.value : undefined,
        )
      }
      options={options}
      placeholder={m.coInvestments_notifications_filterByDeal()}
      value={selectedOption}
      withCheckmark
      withChevron
      wrapOptionLabels
    />
  );
};
